export const NAME_VALIDATION = {
  required: {
    value: true,
    message: 'URL slug is required',
  },
  pattern: {
    value: /^((?!\bideal\b|\bideal4finance\b).)*$/gim,
    message: "URL slug cannot contain the word 'ideal' or 'ideal4finance'",
  },
};
